import Icon, {
  AppstoreOutlined,
  AreaChartOutlined,
  BarChartOutlined,
  BuildOutlined,
  CalculatorOutlined,
  ControlOutlined,
  DollarOutlined,
  FileTextOutlined,
  FundProjectionScreenOutlined,
  GlobalOutlined,
  IdcardOutlined,
  InboxOutlined,
  LineChartOutlined,
  PercentageOutlined,
  PictureOutlined,
  ProfileOutlined,
  SlidersOutlined,
  TableOutlined,
  TagsOutlined
} from '@ant-design/icons';
import { PRIVATE_PATH } from '@/constants';
import { MenuItem } from './Navbar.types';

const UserSettingsIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 36 36" fill="none" aria-hidden>
    <path
      d="M28.0314 9.96429C28.0314 4.45982 23.5715 0 18.0671 0C12.5626 0 8.10278 4.45982 8.10278 9.96429C8.10278 13.2911 9.73403 16.2402 12.2412 18.0482C12.2251 18.0562 12.213 18.0603 12.205 18.0643C10.409 18.8237 8.79787 19.9125 7.41171 21.3027C6.03355 22.6783 4.93636 24.3091 4.18135 26.104C3.4385 27.8617 3.03759 29.7449 3.0001 31.6527C2.99903 31.6956 3.00655 31.7382 3.02222 31.7782C3.03789 31.8181 3.0614 31.8545 3.09136 31.8852C3.12131 31.9159 3.15711 31.9403 3.19664 31.9569C3.23617 31.9736 3.27863 31.9822 3.32153 31.9821H5.72823C5.90099 31.9821 6.04564 31.8415 6.04965 31.6688C6.13001 28.567 7.37153 25.6621 9.5693 23.4603C11.8394 21.1821 14.8528 19.9286 18.0671 19.9286C23.5715 19.9286 28.0314 15.4688 28.0314 9.96429ZM18.0671 16.875C14.2501 16.875 11.1564 13.7812 11.1564 9.96429C11.1564 6.14732 14.2501 3.05357 18.0671 3.05357C21.884 3.05357 24.9778 6.14732 24.9778 9.96429C24.9778 13.7812 21.884 16.875 18.0671 16.875Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.9961 29.5101C34.2851 29.7647 34.3939 30.175 34.2646 30.5412L34.2488 30.5878C33.9258 31.5075 33.4474 32.3546 32.8266 33.1045L32.8252 33.1063L32.7962 33.1409L32.7952 33.142C32.674 33.2881 32.5118 33.3936 32.3297 33.444C32.1472 33.4946 31.9539 33.4871 31.7757 33.4226L30.596 32.9937C30.1583 33.337 29.6785 33.6204 29.1688 33.8367L28.9402 35.1023C28.9062 35.2904 28.8168 35.4642 28.6835 35.6C28.5506 35.7355 28.38 35.827 28.1943 35.8617L28.1928 35.862L28.1464 35.8708C27.2074 36.0434 26.2459 36.0434 25.3069 35.8708L25.3049 35.8704L25.2605 35.862L25.2591 35.8617C25.0733 35.827 24.9028 35.7355 24.7698 35.6C24.6365 35.4642 24.5472 35.2906 24.5131 35.1025L24.2828 33.8294C23.7773 33.6139 23.3029 33.3316 22.8676 32.9902L21.6767 33.4229C21.4987 33.4868 21.3059 33.494 21.1237 33.4436C20.9418 33.3933 20.7797 33.288 20.6583 33.1422L20.627 33.1048C20.0058 32.3563 19.5274 31.5073 19.2046 30.5878L19.2031 30.5836L19.1885 30.5405C19.1259 30.3611 19.1178 30.1666 19.1653 29.9825C19.2131 29.7975 19.315 29.6311 19.4581 29.5058L20.4255 28.6611C20.3906 28.3843 20.3737 28.1038 20.3737 27.824C20.3737 27.5452 20.3906 27.2647 20.4256 26.987L19.4585 26.1426L19.4572 26.1414C19.1668 25.8855 19.0603 25.475 19.1885 25.1076L19.2045 25.0603C19.5271 24.141 20.0089 23.2883 20.6269 22.5432L20.6282 22.5417L20.6581 22.5061C20.7793 22.36 20.9415 22.2544 21.1236 22.204C21.3061 22.1534 21.4994 22.1609 21.6776 22.2254L22.8676 22.6578C23.302 22.3172 23.7776 22.0353 24.2827 21.8191L24.5131 20.5456C24.5472 20.3575 24.6365 20.1838 24.7698 20.048C24.9029 19.9123 25.0737 19.8208 25.2597 19.7862L25.3067 19.7773C26.2377 19.6055 27.2157 19.6055 28.1467 19.7773L28.1484 19.7776L28.1928 19.786C28.3788 19.8207 28.5504 19.9124 28.6835 20.048C28.8168 20.1838 28.9061 20.3574 28.9402 20.5455L29.1688 21.8115C29.6787 22.0282 30.1567 22.3111 30.5956 22.6544L31.7766 22.2251C31.9546 22.1612 32.1475 22.154 32.3296 22.2044C32.5115 22.2547 32.6736 22.36 32.7949 22.5057L32.8262 22.543C33.4451 23.2877 33.9271 24.1407 34.2489 25.0606L34.2502 25.0644L34.2648 25.1076C34.3275 25.2869 34.3355 25.4814 34.288 25.6655C34.2402 25.8506 34.1383 26.0169 33.9952 26.1422L33.0412 26.9764C33.0767 27.2569 33.0949 27.5412 33.0949 27.8257C33.0949 28.1102 33.0767 28.3946 33.0412 28.6751L33.9961 29.5101ZM26.7266 31.0069C28.4844 31.0069 29.9094 29.5819 29.9094 27.8241C29.9094 26.0663 28.4844 24.6414 26.7266 24.6414C24.9688 24.6414 23.5438 26.0663 23.5438 27.8241C23.5438 29.5819 24.9688 31.0069 26.7266 31.0069Z"
      fill="currentColor"
    />
  </svg>
);

// Partial: some routes (raising an IO) are reached from a page, not the sidebar.
/**
 * Icon for the Skyrise Rate Builder group header.
 *
 * Its own rather than borrowed from a child: the group previously reused the
 * EU6 Calculator's icon, which is one of the three items nested beneath it, so
 * the header and one of its children were indistinguishable and the group read
 * as odd beside every other top-level item.
 */
export const RATE_BUILDER_GROUP_ICON = <BuildOutlined />;

export const ITEM_DATA: Partial<Record<PRIVATE_PATH, Omit<MenuItem, 'title'> & { i18nKey: string }>> = {
  [PRIVATE_PATH.MEDIA_PLAN]: {
    i18nKey: 'mediaPlan',
    icon: <ProfileOutlined />,
    key: PRIVATE_PATH.MEDIA_PLAN,
    path: PRIVATE_PATH.MEDIA_PLAN
  },
  [PRIVATE_PATH.IO]: {
    i18nKey: 'io',
    icon: <FileTextOutlined />,
    key: PRIVATE_PATH.IO,
    path: PRIVATE_PATH.IO
  },
  [PRIVATE_PATH.RATE_CARD]: {
    i18nKey: 'rateCard',
    icon: <IdcardOutlined />,
    key: PRIVATE_PATH.RATE_CARD,
    path: PRIVATE_PATH.RATE_CARD
  },
  [PRIVATE_PATH.USER_SETTINGS]: {
    i18nKey: 'userSettings',
    icon: <Icon component={UserSettingsIcon} aria-hidden />,
    key: PRIVATE_PATH.USER_SETTINGS,
    path: PRIVATE_PATH.USER_SETTINGS
  },
  [PRIVATE_PATH.TRADER_CONTROLS_CHANNELS]: {
    i18nKey: 'traderControlsChannels',
    icon: <AppstoreOutlined />,
    key: PRIVATE_PATH.TRADER_CONTROLS_CHANNELS,
    path: PRIVATE_PATH.TRADER_CONTROLS_CHANNELS
  },
  [PRIVATE_PATH.TRADER_CONTROLS_DSP_FEES]: {
    i18nKey: 'traderControlsDspFees',
    icon: <DollarOutlined />,
    key: PRIVATE_PATH.TRADER_CONTROLS_DSP_FEES,
    path: PRIVATE_PATH.TRADER_CONTROLS_DSP_FEES
  },
  [PRIVATE_PATH.TRADER_CONTROLS_KPIS]: {
    i18nKey: 'traderControlsKpis',
    icon: <SlidersOutlined />,
    key: PRIVATE_PATH.TRADER_CONTROLS_KPIS,
    path: PRIVATE_PATH.TRADER_CONTROLS_KPIS
  },
  [PRIVATE_PATH.TRADER_CONTROLS_TRADING_DEALS]: {
    i18nKey: 'traderControlsTradingDeals',
    icon: <TagsOutlined />,
    key: PRIVATE_PATH.TRADER_CONTROLS_TRADING_DEALS,
    path: PRIVATE_PATH.TRADER_CONTROLS_TRADING_DEALS
  },
  [PRIVATE_PATH.TRADER_CONTROLS]: {
    i18nKey: 'traderControls',
    icon: <ControlOutlined />,
    key: PRIVATE_PATH.TRADER_CONTROLS,
    path: PRIVATE_PATH.TRADER_CONTROLS
  },
  [PRIVATE_PATH.CUSTOM_PACKAGE]: {
    i18nKey: 'customPackage',
    icon: <InboxOutlined />,
    key: PRIVATE_PATH.CUSTOM_PACKAGE,
    path: PRIVATE_PATH.CUSTOM_PACKAGE
  },
  [PRIVATE_PATH.EU6_CALCULATOR]: {
    i18nKey: 'eu6Calculator',
    icon: <CalculatorOutlined />,
    key: PRIVATE_PATH.EU6_CALCULATOR,
    path: PRIVATE_PATH.EU6_CALCULATOR
  },
  [PRIVATE_PATH.CALCULATOR_RATE_CARD]: {
    i18nKey: 'calculatorRateCard',
    icon: <GlobalOutlined />,
    key: PRIVATE_PATH.CALCULATOR_RATE_CARD,
    path: PRIVATE_PATH.CALCULATOR_RATE_CARD
  },
  [PRIVATE_PATH.BOOKING_SHEET]: {
    i18nKey: 'bookingSheet',
    icon: <TableOutlined />,
    key: PRIVATE_PATH.BOOKING_SHEET,
    path: PRIVATE_PATH.BOOKING_SHEET
  },
  [PRIVATE_PATH.CREATIVE_LIBRARY]: {
    i18nKey: 'creativeLibrary',
    icon: <PictureOutlined />,
    key: PRIVATE_PATH.CREATIVE_LIBRARY,
    path: PRIVATE_PATH.CREATIVE_LIBRARY,
    disabled: true
  },
  [PRIVATE_PATH.DASHBOARD]: {
    i18nKey: 'dashboard',
    icon: <AreaChartOutlined />,
    key: PRIVATE_PATH.DASHBOARD,
    path: PRIVATE_PATH.DASHBOARD,
    disabled: true
  },
  [PRIVATE_PATH.REPORTS]: {
    i18nKey: 'reports',
    icon: <BarChartOutlined />,
    key: PRIVATE_PATH.REPORTS,
    path: PRIVATE_PATH.REPORTS,
    disabled: true
  },
  [PRIVATE_PATH.FORECASTING]: {
    i18nKey: 'financialYearForecast',
    icon: <FundProjectionScreenOutlined />,
    key: PRIVATE_PATH.FORECASTING,
    path: PRIVATE_PATH.FORECASTING
  },
  [PRIVATE_PATH.FORECASTING_THREE_MONTH]: {
    i18nKey: 'threeMonthForecast',
    icon: <LineChartOutlined />,
    key: PRIVATE_PATH.FORECASTING_THREE_MONTH,
    path: PRIVATE_PATH.FORECASTING_THREE_MONTH
  },
  [PRIVATE_PATH.FORECASTING_MARGINS]: {
    i18nKey: 'campaignMargins',
    icon: <PercentageOutlined />,
    key: PRIVATE_PATH.FORECASTING_MARGINS,
    path: PRIVATE_PATH.FORECASTING_MARGINS
  },
  [PRIVATE_PATH.TRADER_SHEET]: {
    i18nKey: 'traderSheet',
    icon: <TableOutlined />,
    key: PRIVATE_PATH.TRADER_SHEET,
    path: PRIVATE_PATH.TRADER_SHEET,
    disabled: true
  }
};
